import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Error from "@material-ui/icons/Error";
import MainButton from "../Shared/Components/MainButton";
import CustomDialog from "../Shared/Components/CustomDialog";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  dialogTitleRoot: {
    fontSize: "1.5rem",
    fontWeight: 400,
  },

  TypographyCaption: {
    fontSize: 12,
    lineHeight: 1.7,
  },
  errorResult: {
    background: "#ED1C29",
    color: "#fff",
    padding: "20px",
    borderRadius: "4px",
    fontSize: 16,
    lineHeight: 1.7,
    textAlign: "center",
    "& p": { color: "#fff !important" },
  },
  errorResultIcon: {
    float: "left",
  },
  codeFieldWrapper: {
    display: "flex",
    justifyContent: "center",
    marginTop: 24,
    marginBottom: 32,
  },
  codeField: {
    fontSize: "26px",
    borderRadius: 4,
    height: 40,
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      height: 56,
      width: "100%",
    },
  },
  codeFieldInput: {
    fontSize: "15px",
    lineHeight: "18px",
    textAlign: "center",
    height: 20,
    padding: "10px 16px",
    minWidth: 320,
    [theme.breakpoints.down("xs")]: {
      padding: "0 5px",
      height: 56,
      minWidth: 50,
    },
  },
  activeButton: {
    padding: "6px 15px",
  },
}));

const LoadConfiguration = (props) => {
  const { workInProgress, onLoadClick, errorMessage, show, onClose, loadCode } = props;
  const classes = useStyles(props);
  const { t } = useTranslation("loadConfiguration");

  const onChange = (e) => {
    props.onCodeChange(e.target.value);
  };

  return (
    <CustomDialog
      open={show}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      dialogTitle={t("loadConfiguration")}
      onCancel={onClose}
    >
      <DialogContent>
        {workInProgress && (
          <Typography
            variant="body1"
            classes={{ root: classes.TypographyCaption }}
            id="alert-dialog-description"
          >
            {t("loading")}
          </Typography>
        )}
        {!workInProgress && (
          <React.Fragment>
            <Typography
              variant="body1"
              classes={{ root: classes.TypographyCaption }}
              id="alert-dialog-description"
            >
              {t("existingCodeText")}
            </Typography>
            <div className={classes.codeFieldWrapper}>
              <TextField
                className={classes.codeField}
                value={loadCode}
                variant={"outlined"}
                onChange={onChange}
                placeholder={t("configurationCode")}
                InputProps={{
                  classes: {
                    input: classes.codeFieldInput,
                  },
                  disableUnderline: true,
                }}
              />
            </div>
          </React.Fragment>
        )}
        {errorMessage && (
          <div className={classes.errorResult}>
            <Error className={classes.errorResultIcon} />
            <Typography variant="body1">{errorMessage}</Typography>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <MainButton
          onClick={onLoadClick}
          variant="contained"
          size="medium"
          className={clsx(classes.activeButton, "primaryButton")}
        >
          Übernehmen
        </MainButton>
      </DialogActions>
    </CustomDialog>
  );
};
LoadConfiguration.propTypes = {
  onLoadClick: PropTypes.func,
  onClose: PropTypes.func,
  onCodeChange: PropTypes.func,
  loadCode: PropTypes.string,
  errorMessage: PropTypes.string,
  classes: PropTypes.object,
  workInProgress: PropTypes.bool,
  show: PropTypes.bool,
};
export default LoadConfiguration;
